
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TReport } from "@/models/report";

const ICONS = {
  alert: "alert-circle-outline",
};

const REPORT_PARSE_TYPE = "html";

const NOT_GENERATED_ERROR = "not_generated";

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    NotificationTemplate: () =>
      import("@/components/NotificationTemplate/NotificationTemplate.vue"),
    NotificationDataNotLoaded: () =>
      import("@/components/Notifications/NotificationDataNotLoaded.vue"),
    CoverLetter: () => import("@/components/CoverLetter/CoverLetter.vue"),
    Attachments: () =>
      import("@/modules/Services/Template/views/HOEmail/components/Attachments.vue"),
  },
})
export default class HOEmail extends Vue {
  loading = false;

  error = false;

  notGenerated = false;

  icons = ICONS;

  src: API_TReport = {
    content: "",
    eligibility_result: "",
    user_name: "",
    widget_type: "",
    has_child_case: false,
    is_sl_started: false,
    if_sponsor: false,
  };

  get covertLetterProps() {
    const { src, serviceId, alias } = this;

    const isEditable = true;

    const isHOEmail = true;

    return { src, serviceId, alias, isEditable, isHOEmail };
  }

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get alias(): string {
    const { query, params } = this.$route;

    return (query?.report_template_alias || params?.report_template_alias || "") as string;
  }

  async fetchReport() {
    try {
      this.loading = true;
      this.error = false;
      this.notGenerated = false;

      const { serviceId } = this;

      if (!serviceId) return;

      const { data } = await this.axios.get(
        API_ROUTES.CASE_REPORT_PARSE(serviceId, this.alias, REPORT_PARSE_TYPE)
      );

      if (data?.Message === NOT_GENERATED_ERROR) this.notGenerated = true;

      if (!data) return;

      this.src = { ...data };
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  update(payload: string) {
    this.src.content = payload;
  }

  mounted() {
    this.fetchReport();
  }

  generateLoading = false;

  async generate() {
    this.generateLoading = true;

    const { serviceId } = this;

    if (!serviceId) return;

    try {
      const url = API_ROUTES.CASE_REPORT_GENERATE(serviceId, this.alias);

      await this.axios.get(url);
    } catch {
      this.error = true;
    } finally {
      this.generateLoading = false;

      await this.fetchReport();
    }
  }
}
